// extracted by mini-css-extract-plugin
export var growableInput = "_8r-0";
export var tagContainer = "_8r-2";
export var textInput = "_8r-1";